import { render } from "./Lubrificantes.vue?vue&type=template&id=d823dfb6&scoped=true&ts=true"
import script from "./Lubrificantes.vue?vue&type=script&lang=ts"
export * from "./Lubrificantes.vue?vue&type=script&lang=ts"

import "./Lubrificantes.vue?vue&type=style&index=0&id=d823dfb6&scoped=true&lang=css"

import exportComponent from "/Users/camp2/Devs/indicar/indicar-gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d823dfb6"]])

export default __exports__